import * as GUI from 'babylonjs-gui'
import { IMesh, IModel } from '../../type/modelType'
import { removeGUI } from '../commonLib/vr'
import {
  changeColorByMeshName,
  changeTextureByMeshName,
  switchingVariant,
} from './customization'

export const setVrGUI = (
  advancedTexture: GUI.AdvancedDynamicTexture,
  model: IModel
) => {
  const sv = new GUI.ScrollViewer()
  sv.width = 0.24
  sv.height = 1
  sv.background = '#FEFEFE'
  sv.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT

  advancedTexture.addControl(sv)

  var panel = new GUI.StackPanel()
  panel.height = 1
  sv.addControl(panel)

  const button = GUI.Button.CreateSimpleButton('closegui', 'X')
  button.width = '24px'
  button.height = '24px'
  button.color = '#333333'
  button.thickness = 0
  button.cornerRadius = 50
  button.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT
  // button.background = textureOptions[index].hex
  button.onPointerClickObservable.add(function () {
    removeGUI()
  })

  const rect = new GUI.Rectangle()
  rect.width = 1
  rect.height = '24px'
  rect.thickness = 0
  rect.addControl(button)
  panel.addControl(rect)

  const rect1 = new GUI.Rectangle()
  rect1.width = 1
  rect1.height = 1
  rect1.cornerRadius = 5
  rect1.thickness = 0
  rect1.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT
  rect1.top = '0px'
  rect1.left = '0px'
  panel.addControl(rect1)
  guiByModelConfig(rect1, model)
}

const guiColors = (
  container: GUI.Container,
  meshGroup: IMesh,
  model: IModel
) => {
  if (meshGroup.colors) {
    const colorOptions = meshGroup.colors.filter(c => c.isOption)

    const BTN_HEIGHT = 48
    const COLS = 6

    const grid = new GUI.Grid()
    grid.width = 1
    grid.height = `${Math.ceil(colorOptions.length / COLS) * BTN_HEIGHT}px`

    for (let i = 0; i < COLS; i++) {
      grid.addColumnDefinition(0.2)
    }
    for (let i = 0; i < colorOptions.length; i += COLS) {
      const rowNumber = Math.floor(i / COLS)

      grid.addRowDefinition(BTN_HEIGHT, true)

      for (let j = 0; j < COLS; j++) {
        const rect1 = new GUI.Rectangle()
        rect1.thickness = 0

        const index = rowNumber * COLS + j

        if (colorOptions[index]) {
          const button = GUI.Button.CreateSimpleButton('but1', '')
          button.width = '40px'
          button.height = '40px'
          button.color = '#333333'
          button.thickness = 0
          button.cornerRadius = 50
          button.background = colorOptions[index].hex
          button.onPointerClickObservable.add(function () {
            changeColorByMeshName(
              colorOptions[index],
              meshGroup.variants.map(v => v.meshName),
              model.id
            )
          })

          rect1.addControl(button)

          grid.addControl(rect1, rowNumber, j)
        }
      }
    }

    grid.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM

    container.addControl(grid)
  }
}

const guiTextures = (
  container: GUI.Container,
  meshGroup: IMesh,
  model: IModel
) => {
  if (meshGroup.textures) {
    const textureOptions = meshGroup.textures.filter(c => c.isOption)

    const BTN_HEIGHT = 48
    const COLS = 6

    const grid = new GUI.Grid()
    grid.width = 1
    grid.height = `${Math.ceil(textureOptions.length / COLS) * BTN_HEIGHT}px`

    for (let i = 0; i < COLS; i++) {
      grid.addColumnDefinition(0.2)
    }
    for (let i = 0; i < textureOptions.length; i += COLS) {
      const rowNumber = Math.floor(i / COLS)

      grid.addRowDefinition(BTN_HEIGHT, true)

      for (let j = 0; j < COLS; j++) {
        const rect1 = new GUI.Rectangle()
        rect1.thickness = 0

        const index = rowNumber * COLS + j

        if (textureOptions[index]) {
          const button = GUI.Button.CreateImageButton(
            'texturebtn',
            '',
            textureOptions[index].source.texture
          )
          if (button.image) {
            button.image.stretch = GUI.Image.STRETCH_FILL
            button.image.width = '40px'
            button.image.height = '40px'
          }

          button.width = '40px'
          button.height = '40px'
          button.color = '#333333'
          button.thickness = 0
          button.cornerRadius = 50
          button.onPointerClickObservable.add(function () {
            changeTextureByMeshName(
              textureOptions[index],
              meshGroup.variants.map(v => v.meshName),
              model.id
            )
          })

          rect1.addControl(button)

          grid.addControl(rect1, rowNumber, j)
        }
      }
    }

    grid.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM

    container.addControl(grid)
  }
}

const guiMeshes = (
  container: GUI.Container,
  meshGroup: IMesh,
  model: IModel
) => {
  if (meshGroup.variants && meshGroup.variants.some(c => c.isOption)) {
    const variantOptions = meshGroup.variants.filter(c => c.isOption)

    const BTN_HEIGHT = 48
    const COLS = variantOptions.length

    const grid = new GUI.Grid()
    grid.width = 1
    grid.height = `${
      (Math.floor(variantOptions.length / COLS) + 1) * BTN_HEIGHT
    }px`

    for (let i = 0; i < COLS; i++) {
      grid.addColumnDefinition(0.2)
    }
    for (let i = 0; i < variantOptions.length; i += COLS) {
      const rowNumber = Math.floor(i / COLS)

      grid.addRowDefinition(BTN_HEIGHT, true)

      for (let j = 0; j < COLS; j++) {
        const rect1 = new GUI.Rectangle()
        rect1.thickness = 0
        rect1.paddingTopInPixels = 3
        rect1.paddingBottomInPixels = 3
        rect1.paddingLeftInPixels = 3
        rect1.paddingRightInPixels = 3

        const index = rowNumber * COLS + j

        if (variantOptions[index]) {
          const button = GUI.Button.CreateSimpleButton(
            'but1',
            variantOptions[index].title
          )
          button.width = 1
          button.height = '40px'
          button.color = '#333333'
          button.thickness = 1
          button.cornerRadius = 5
          button.onPointerClickObservable.add(function () {
            switchingVariant(
              variantOptions[index].meshName,
              variantOptions,
              model.id
            )

            console.log(model.id)
          })

          rect1.addControl(button)

          grid.addControl(rect1, rowNumber, j)
        }
      }
    }

    grid.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM

    container.addControl(grid)
  }
}

const guiMeshGroup = (
  container: GUI.Container,
  meshGroup: IMesh,
  model: IModel
) => {
  var panel = new GUI.StackPanel()
  panel.height = 1
  container.addControl(panel)

  const text = new GUI.TextBlock()
  text.text = meshGroup.title
  text.fontSize = 18
  text.height = '24px'

  panel.addControl(text)

  if (meshGroup.colors) {
    const text = new GUI.TextBlock()
    text.text = 'Colors'
    text.fontSize = 16
    text.height = '16px'
    text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT
    panel.addControl(text)

    guiColors(panel, meshGroup, model)
  }

  if (meshGroup.textures) {
    const text = new GUI.TextBlock()
    text.text = 'Materials'
    text.fontSize = 16
    text.height = '16px'
    text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT
    panel.addControl(text)
    guiTextures(panel, meshGroup, model)
  }

  if (meshGroup.variants && meshGroup.variants.some(c => c.isOption)) {
    const text = new GUI.TextBlock()
    text.text = 'Varaints'
    text.fontSize = 16
    text.height = '16px'
    text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT
    panel.addControl(text)
    guiMeshes(panel, meshGroup, model)
  }
}

export const guiByModelConfig = (container: GUI.Container, model: IModel) => {
  var panel = new GUI.StackPanel()
  panel.height = 1
  container.addControl(panel)

  model.meshes.forEach((meshGroup, index) => {
    const rect1 = new GUI.Rectangle()
    rect1.width = 1
    rect1.height = '300px'
    rect1.cornerRadius = 5
    rect1.thickness = 1
    rect1.paddingTopInPixels = 15
    rect1.paddingBottomInPixels = 15
    rect1.paddingLeftInPixels = 15
    rect1.paddingRightInPixels = 15

    guiMeshGroup(rect1, meshGroup, model)

    panel.addControl(rect1)
  })
}
